const ua = () => window.navigator.userAgent || ''

const getQS = (name: string): string | null => {
  try {
    const s = window.location.search ? window.location.search.slice(1) : ''
    const h = window.location.hash || ''
    const qIndex = h.indexOf('?')
    const hashSearch = qIndex !== -1 ? h.slice(qIndex + 1) : ''
    const pairs = `${s}&${hashSearch}`.split('&')
    for (const p of pairs) {
      const idx = p.indexOf('=')
      if (idx > -1 && decodeURIComponent(p.slice(0, idx)) === name) {
        return decodeURIComponent(p.slice(idx + 1))
      }
    }
    return null
  } catch {
    return null
  }
}

export const isTudoApp = ua().indexOf('tudoApp') > -1
export const isOutFieldApp = ua().indexOf('outfield') > -1
export const isSandsTalkFlutterApp = ua().indexOf('sandsTalkFlutterApp') > -1
export const isSandsTalkNativeApp = ua().indexOf('sandsTalkNativeApp') > -1 || ua().indexOf('myDriverApp') > -1
export const isSandsTalkSEAsiaOutfieldApp = ua().indexOf('seAsiaOutfield') > -1
export const isSandsTalkPhOutfieldApp = ua().indexOf('PhOutfield') > -1
export const isSandsTalkMiddleEastApp = ua().indexOf('middleEastField') > -1
export const isSandsTalkBrMexApp =
  ua().indexOf('brOutfieldApp') > -1 ||
  ua().indexOf('mexOutfieldApp') > -1 ||
  ua().indexOf('egOutfieldApp') > -1 ||
  ua().indexOf('brDriverApp') > -1
export const isSandsTalkBrDriverApp = ua().indexOf('brDriverApp') > -1
export const isBranchManagerApp = ua().indexOf('cn_network_app') > -1
export const isWisdomRabbitApp = ua().indexOf('cn_rabbit_app') > -1
export const isSandsTalkMSFlutterApp = ua().indexOf('my_outfieid_app') > -1
export const isFeishu = !!window.h5sdk
export const isWechat = /micromessenger/i.test(ua()) && ua().indexOf('wxwork') === -1
export const isComWx = /micromessenger/i.test(ua()) && ua().indexOf('wxwork') > -1

export const isCnDriverAppSource = (): boolean => {
  const source =
    getQS('source') === 'cn_driver_app' || ua().indexOf('cn_driver_app') > -1 || getQS('source') === 'cn_chijun_app'
  return source
}

export const isChijunAppSource = (): boolean => {
  return getQS('source') === 'cn_chijun_app'
}

export const isCnRabbitAppAssetInv = (): boolean => {
  return getQS('source') === 'cn_rabbit_app_project' || ua().indexOf('cn_rabbit_app_project') > -1
}

export { getQS as getQueryString }
